import React from 'react';

export default function VoiceEnrollForm({ title, subtitle, formData, setFormData, fields, onSubmit, submitting, submitLabel }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f2f4f8', padding: '24px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ maxWidth: '500px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ color: '#0d4a33', fontSize: '28px', marginBottom: '8px' }}>{title}</h1>
          <p style={{ color: '#6b7280', fontSize: '16px' }}>{subtitle}</p>
        </div>

        <div style={{ background: 'white', borderRadius: '16px', padding: '32px', boxShadow: '0 16px 40px rgba(0,0,0,0.1)' }}>
          {fields.map((field) => (
            <div key={field.name} style={{ marginBottom: field.name === fields[fields.length - 1]?.name ? '24px' : '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                {field.label} {field.required && '*'}
              </label>
              {field.type === 'select' ? (
                <select
                  value={formData[field.name]}
                  onChange={e => setFormData(f => ({ ...f, [field.name]: e.target.value }))}
                  style={{ width: '100%', padding: '14px 16px', fontSize: '16px', border: '2px solid #e5e7eb', borderRadius: '10px', boxSizing: 'border-box' }}
                >
                  {field.options.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              ) : (
                <input
                  type={field.type || 'text'}
                  value={formData[field.name]}
                  onChange={e => setFormData(f => ({ ...f, [field.name]: e.target.value }))}
                  placeholder={field.placeholder}
                  style={{ width: '100%', padding: '14px 16px', fontSize: '16px', border: '2px solid #e5e7eb', borderRadius: '10px', boxSizing: 'border-box' }}
                />
              )}
            </div>
          ))}

          <button
            onClick={onSubmit}
            disabled={submitting}
            style={{
              width: '100%',
              padding: '16px 32px',
              fontSize: '18px',
              fontWeight: '600',
              background: submitting ? '#e5e7eb' : '#0d4a33',
              color: submitting ? '#9ca3af' : 'white',
              border: 'none',
              borderRadius: '12px',
              cursor: submitting ? 'not-allowed' : 'pointer'
            }}
          >
            {submitting ? 'Saving...' : submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
